// 改组件客户端执行
// import { SchemaVariant } from '@projectTypes/template'
import type { Product, ProductMedia, ProductVariant } from '../types/product'
import { CouponChannel } from '../const.js'
// import Cookies from 'js-cookie'
// import { Attribute, HasMetafieldsIdentifier } from 'lib/shopify/gql'
// import { HasMetafieldQueryRoot } from 'lib/shopify/types/fetcher'
// import { useEffect, useState } from 'react'

// import { PartialRecord } from './type-helper'

export type SchemaVariant = {
  variant: {
    handle: string
    sku: string
  }
}

// 判断对象是否为空
export function isObjEmpty(obj?: Record<string, any>) {
  if (!obj) return true
  else {
    return Object.keys(obj).length === 0
  }
}

export function atobID(id: string) {
  if (id && typeof id === 'string' && id.includes('/')) {
    return id.split('/').pop()?.split('?')?.shift()
  } else {
    return id
  }
}

export function btoaID(id: string, type: 'ProductVariant' | 'Product' = 'ProductVariant') {
  return `gid://shopify/${type}/${id}`
}

// 皮肤站三级域名
export const getThemeLocale = (locale: string) => {
  if (locale === 'eu-de') return 'de'
  if (locale === 'eu-en') return 'eu'
  if (locale === 'au') return 'au'
  return locale
}

/**
 * 生成 metafieldIdentifiers 查询参数
 */
// export function constructMetafieldIdentifiersQueryParams<T extends HasMetafieldQueryRoot>(
//   metafieldIdentifiers: PartialRecord<T, HasMetafieldsIdentifier[]> = {},
// ): PartialRecord<`${T}MetafieldIdentifiers`, HasMetafieldsIdentifier[]> {
//   const identifiers = Object.entries(metafieldIdentifiers).reduce(
//     (queryInput, [key, value]) => {
//       const metafieldIdentifiers = value as HasMetafieldsIdentifier[]
//       queryInput[`${key}MetafieldIdentifiers`] = metafieldIdentifiers
//         .filter((item) => !item.namespace.startsWith(metafieldNamespacePrefix))
//         .map((item) => ({
//           namespace: `${metafieldNamespacePrefix}combo`,
//           key: item.namespace,
//         }))
//         .concat(metafieldIdentifiers)
//       return queryInput
//     },
//     {} as PartialRecord<`${T}MetafieldIdentifiers`, HasMetafieldsIdentifier[]>,
//   )
//   return identifiers
// }

// export function cleanShopKey(shop: Shop) {
//   const { privacyPolicy, refundPolicy, shippingPolicy, termsOfService, subscriptionPolicy, ...otherShop } = shop
//   return otherShop
// }

// export const delHtmlTag = (str?: string) => {
//   return str ? String(str).replace(/<[^>]+>/g, '') : ''
// }

export const getNormalCoupon = ({ variant }: { variant?: ProductVariant }) => {
  return variant?.coupons?.find(coupon => coupon.discount_type !== CouponChannel.WSCH)
}

// export const setCartSecretCookie = ({ cart }) => {
//   const key = cart.id.split('?key=')[1]
//   const id = cart.id.split('?key=')[0].split('gid://shopify/Cart/')[1]
//   Cookies.set(id, key, {
//     Domain: window.location.hostname.split('.').reverse().slice(0, 2).reverse().join('.'),
//   })
// }

// export const languageCode = (locale: string) =>
//   ({
//     us: 'US',
//     uk: 'GB',
//     ca: 'CA',
//     fr: 'FR',
//     au: 'AU',
//     my: 'MY',
//     vn: 'VN',
//     it: 'IT',
//     de: 'DE',
//     cl: 'CL',
//   })[locale] || 'US'

// shopify 的特殊文件转换规则
const umlautMap = {
  '\u00dc': 'U',
  '\u00c4': 'A',
  '\u00d6': 'O',
  '\u00fc': 'u',
  '\u00e4': 'a',
  '\u00f6': 'o',
  '\u00df': 'ss',
  '\u00E8': 'e',
}

// 替换字符串中的特殊字符
export function replaceUmlaut(str: string) {
  return str
    .replace(/[\u00dc|\u00c4|\u00d6][a-z]/g, a => {
      const big = umlautMap[a.slice(0, 1) as keyof typeof umlautMap]
      return big.charAt(0) + big.charAt(1).toLowerCase() + a.slice(1)
    })
    .replace(new RegExp('[' + Object.keys(umlautMap).join('|') + ']', 'g'), a => umlautMap[a as keyof typeof umlautMap])
}

// 将字符串转换为 slug
export function handle(str: string) {
  return replaceUmlaut(str)
    .replace(/ /g, '-')
    .replace(/[^a-zA-Z0-9-]/g, '')
    .toLowerCase()
}

// get variant image index
export function getVariantImageIndex({
  mediaList,
  variant,
}: {
  variant: ProductVariant
  mediaList: ProductMedia[]
}): null | number {
  const src = variant?.image?.url
  return src ? mediaList.map(media => media.image?.url).findIndex(imageSrc => imageSrc == src) : null
}

// get images belong to variant
export function getVariantMediaList({ product, variant }: { variant: ProductVariant; product: Product }) {
  const currentVariantImageIndex = getVariantImageIndex({ mediaList: product.media, variant })

  if (currentVariantImageIndex !== null) {
    const nextVariantImageIndex =
      product.variants
        .filter(v => variant.id !== v.id)
        .map(v => getVariantImageIndex({ mediaList: product.media, variant: v }))
        .find(index => index !== null && index > currentVariantImageIndex) || -1

    // current variant images, if no next variant found, return images from current index to the end
    return product.media.slice(
      currentVariantImageIndex,
      nextVariantImageIndex === -1 ? product.media.length : nextVariantImageIndex
    )
  } else {
    // if no variant image found, return all images
    return product.media
  }
}

// // 通过选择 option 获取 variant
// export function getVariantFromSelectedOptions({
//   product,
//   selectedOptions,
// }: {
//   product: Product
//   selectedOptions: Record<string, string>
// }) {
//   return product.variants.find((variant) => {
//     return Object.entries(selectedOptions).every(([key, value]) =>
//       variant.options.find((option) => {
//         if (option.__typename === 'MultipleChoiceOption' && option.name === key) {
//           return option.values.find((v) => v.label === value)
//         }
//       }),
//     )
//   })
// }

// export const getURLParameter = (name, url = window.location.href) => {
//   name = name.replace(/[\[\]]/g, '\\$&') // 将方括号转义，以便在正则表达式中使用
//   var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)') // 创建匹配参数的正则表达式
//   var results = regex.exec(url) // 在URL中查找匹配的参数
//   if (!results) return null // 如果没有找到匹配的参数，则返回null
//   if (!results[2]) return '' // 如果参数的值为空，则返回空字符串
//   return decodeURIComponent(results[2]) // 返回解码后的参数值
// }

export const checkItemAvailableForProduct = ({
  product,
  item,
  variant,
}: {
  product: Product
  variant: ProductVariant
  item?: {
    includeTags?: string[]
    includeProducts?: SchemaVariant[]
    excludeProducts?: SchemaVariant[]
  }
}) => {
  if (item) {
    if (Number(item?.includeTags?.length) > 0) {
      return product.tags?.find(tag => item?.includeTags?.includes(tag))
    } else if (Number(item?.includeProducts?.length) > 0) {
      return item.includeProducts?.find(p => p?.variant?.handle === product.handle && p?.variant?.sku === variant.sku)
    } else if (Number(item?.excludeProducts?.length) > 0) {
      return !item.excludeProducts?.find(p => p?.variant?.handle === product.handle && p?.variant?.sku === variant.sku)
    } else {
      return true
    }
  } else {
    return false
  }
}
// export const getReferralAttributes = () => {
//   const inviteCode = Cookies.get('invite_code')
//   const playModeId = Cookies.get('playModeId')
//   const popup = Cookies.get('_popup')
//   if (inviteCode && playModeId) {
//     return popup
//       ? [
//           { key: '_invite_code', value: inviteCode ? inviteCode : '' },
//           { key: '_play_mode_id', value: playModeId ? playModeId : '' },
//           { key: '_popup', value: popup },
//         ]
//       : [
//           { key: '_invite_code', value: inviteCode ? inviteCode : '' },
//           { key: '_play_mode_id', value: playModeId ? playModeId : '' },
//         ]
//   }
//   return []
// }

// export function useH2Toc(htmlContent: string) {
//   const [toc, setToc] = useState<{ updatedHtmlContent: string; dataList: { url: string; text: string }[] }>({
//     updatedHtmlContent: htmlContent,
//     dataList: [],
//   })

//   useEffect(() => {
//     if (typeof window === 'undefined' || typeof document === 'undefined') return
//     const div = document.createElement('div')
//     div.innerHTML = htmlContent
//     const h2s = div.querySelectorAll('h2')
//     const dataList: { url: string; text: string }[] = []
//     h2s.forEach((h2, idx) => {
//       const text = (h2.textContent || '').trim()
//       if (!text) return
//       const id = encodeURIComponent(text).replace(/'/g, '&#39;')
//       h2.setAttribute('id', id)
//       dataList.push({ url: id, text })
//     })
//     setToc({ updatedHtmlContent: div.innerHTML, dataList })
//   }, [htmlContent])

//   return toc
// }

// export const isAttributesEqual = (oldAttributes: Attribute[], newAttributes: Attribute[]) => {
//   // 比对两个数据是否完全相同
//   // 检查数组长度是否相同
//   if (oldAttributes?.length !== newAttributes?.length) {
//     return false
//   }

//   // 将数组转换为 Map 以便快速查找
//   const oldMap = new Map(oldAttributes.map((attr) => [attr.key, attr.value]))
//   const newMap = new Map(newAttributes.map((attr) => [attr.key, attr.value]))

//   // 检查所有 key 是否都存在且值相同
//   for (const [key, value] of newMap) {
//     if (!oldMap.has(key) || oldMap.get(key) !== value) {
//       return false
//     }
//   }

//   return true
// }

// // 检查输入框中的特殊符号
// export function validateSpecialCharacters(input: string): { isValid: boolean; invalidChars: string[] } {
//   // 定义不允许的特殊符号
//   const invalidSpecialChars = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]/g

//   const matches = input.match(invalidSpecialChars)
//   const invalidChars = matches ? [...new Set(matches)] : []

//   return {
//     isValid: invalidChars.length === 0,
//     invalidChars,
//   }
// }

// // 获取特殊符号的错误提示信息
// export function getSpecialCharErrorMessage(invalidChars: string[]): string {
//   if (invalidChars.length === 0) return ''

//   const uniqueChars = [...new Set(invalidChars)]
//   if (uniqueChars.length === 1) {
//     return `不允许使用特殊符号: ${uniqueChars[0]}`
//   } else {
//     return `不允许使用以下特殊符号: ${uniqueChars.join(', ')}`
//   }
// }
